import { render, staticRenderFns } from "./SlideComponent.vue?vue&type=template&id=2404cce2&scoped=true&"
import script from "./SlideComponent.vue?vue&type=script&lang=js&"
export * from "./SlideComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2404cce2",
  null
  
)

export default component.exports